import { render } from "./PantallaInicio.vue?vue&type=template&id=1d59c8a8&scoped=true"
import script from "./PantallaInicio.vue?vue&type=script&lang=js"
export * from "./PantallaInicio.vue?vue&type=script&lang=js"

import "./PantallaInicio.vue?vue&type=style&index=0&id=1d59c8a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d59c8a8"]])

export default __exports__